module.exports = "/images/vendor/svg-country-flags/svg/bg.svg?b0e59e45b564afb05ed8141b3672628c";